// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".close-btn[data-v-62725fbc]{position:absolute;top:6px;right:6px}.modal-body[data-v-62725fbc]{padding:32px}.modal-footer[data-v-62725fbc]{border-top:1px solid #e8ecf4!important}.modal-footer_sticky[data-v-62725fbc]{position:sticky;bottom:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
